<script>
import QuestionFase from "../assets/img/icon/face/question_face.vue";
export default {
  name: "ConfirmationModal",
  components: { QuestionFase },
  props: {
    accept: {
      type: Function,
      default: null,
    },
    reject: {
      type: Function,
      default: null,
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    okText: {
      type: String,
      default: "Aceptar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
  },
  methods: {
    onAccept() {
      this.$emit("accept");
      if (this.accept) {
        this.accept();
      }
    },
    onReject() {
      this.$emit("reject");
      if (this.reject) {
        this.reject();
      }
    },
    onOverlayClick(event) {
      if (event.target === event.currentTarget) {
        this.onReject();
      }
    }
  },
};
</script>

<template>
  <div
    class="confirmModal-overlay"
    v-if="isVisible"
    @click="onOverlayClick"
  >
    <div class="confirmModal-dialog">
      <article class="confirmModal">
        <header class="confirmModal-header">
          <QuestionFase class="confirmModal-icon"></QuestionFase>
        </header>
        <main class="confirmModal-body">
          <slot>
            ¿Estás seguro que deseas continuar?
          </slot>
        </main>
        <footer class="confirmModal-footer">
          <button
            type="button"
            class="confirmModal-footer__button confirmModal-footer__button-cancel"
            @click="onReject"
          >
            
            {{ 
              cancelText 
            }}
          </button>
          <button
            type="button"
            class="confirmModal-footer__button confirmModal-footer__button-accept"
            @click="onAccept"
          >
            {{ okText }}
          </button>
        </footer>
      </article>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$color_linki: rgb(0, 218, 212);

.confirmModal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Adjusted z-index */
}

.confirmModal-dialog {
  background-color: #fff;
  border-radius: 15px;
  position: relative;
  z-index: 1050;
  overflow: visible; 
  font-weight: 600;
}

.confirmModal-icon {
  position: absolute;
  top: -70px;
  left: 0;
  right: 0;
  margin: auto;
  height: 110px;
  width: 110px;
  z-index: 1;
}

.confirmModal-body {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  padding: 40px 10px 35px 10px;
  color: rgba(var(--bs-secondary-rgb)) !important;
  text-align: center;
  min-width: 300px;
}

.confirmModal-body::after {
  content: "";
  position: absolute;
  bottom: -25px;
  right: -25px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  border: 16px solid $color_linki;
  z-index: -1; /* Behind modal body */
}

.confirmModal-footer {
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -20px;
  gap: 16px;
  padding: 0 20px; // Añadido para dar espacio en los laterales
}

.confirmModal-footer__button {
  border-radius: 30px;
  padding: 6px 16px;
  border: 2px solid $color_linki;
  z-index: 1051; 
  font-weight: 600;
  min-width: 120px; // Añadido ancho mínimo
  flex: 1; // Añadido para que los botones ocupen el mismo espacio
  max-width: 160px; // Opcional: limitar el ancho máximo
}

.confirmModal-footer__button-cancel {
  background-color: #fff;
  color: $color_linki;
}

.confirmModal-footer__button-accept {
  color: #fff;
  background-color: $color_linki;
}

.close {
  background: none;
  border: none;
  font-size: 2rem;
}
</style>
